export default {
      id: "small-chevron-right-12-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite-46b249.svg#small-chevron-right-12-usage",
      toString: function () {
        return this.url;
      }
    }